import type { RouteRecordRaw } from 'vue-router'

import configTheme from '@/config/theme.json'
import { auth } from '@/middlewares/auth'
import { featureEnabled } from '@/middlewares/feature'

export const CUSTOMER_PANEL_PATH = '/:locale([a-z]{2})?/customer-panel/'

export const customerPanelParentMeta = {
  middleware: [auth()],
}

export interface CustomerPanelChildMeta {
  meta: NonNullable<RouteRecordRaw['meta']>
  name: string
  path: string
}

/** Names, paths, and nav meta only — no CP page modules. */
export const customerPanelChildMeta: CustomerPanelChildMeta[] = [
  {
    meta: {
      icon: configTheme.icons.favorites,
      title: 'favorites',
    },
    name: 'cp-favorites',
    path: 'favorites/',
  },
  {
    meta: {
      icon: 'bell',
      middleware: [featureEnabled(['savedSearches'])],
      title: 'savedSearches',
    },
    name: 'cp-saved-searches',
    path: 'saved-searches/',
  },
  {
    meta: {
      icon: 'calendar',
      middleware: [featureEnabled(['cpanelVisits'])],
      title: 'visits',
    },
    name: 'cp-visits',
    path: 'visits/',
  },
  {
    meta: {
      icon: 'myOffers',
      middleware: [featureEnabled(['cpanelOffers'])],
      title: 'offers',
    },
    name: 'cp-offers',
    path: 'offers/',
  },
  {
    meta: {
      icon: 'settings',
      title: 'accountSettings',
    },
    name: 'cp-account-settings',
    path: 'account-settings/',
  },
]

export const toCustomerPanelChildRoute = (
  child: CustomerPanelChildMeta,
  component: NonNullable<RouteRecordRaw['component']>,
): RouteRecordRaw => ({
  component,
  meta: child.meta,
  name: child.name,
  path: child.path,
})
